<script setup lang="ts"></script>

<template>
  <div class="tickets-selector-modal" />
</template>

<style scoped lang="scss"></style>
